import React from "react";

const InnerContactInfo = () => {
  const info_items = [
    {
      src: "/img/icon/loction_icon03.png",
      title: "Address",
      desc: (
        <>
          <p>Aditya University, Surampalem</p>
        </>
      ),
    },
    {
      src: "/img/icon/mail_icon03.png",
      title: "Gmail",
      desc: (
        <>
          <a href="mailto:saichanduadapa951@gmail.com">saichanduadapa951@gmail.com</a>
        </>
      ),
    },
    {
      src: "/img/icon/phone_icon03.png",
      title: "Phone",
      desc: (
        <>
          <a href="tel:9381833711">+91 9381833711</a>
        </>
      ),
    },
  ];

  return (
    <ul className="list-wrap">
      {info_items.map((x, index) => (
        <li key={index}>
          <div className="contact-info-item">
            <div className="icon">
              <img src={x.src} alt="" />
            </div>
            <div className="content">
              <h6 className="title" style={{color :"whitesmoke"}}>{x.title}</h6>
              {x.desc}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default InnerContactInfo;
